import React from 'react';

const AddSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M10.1894 7.96091L10.1967 1.63378C10.1967 1.35638 10.0865 1.09035 9.89039 0.894197C9.69424 0.698047 9.4282 0.587852 9.15081 0.587852C8.87341 0.587852 8.60737 0.698048 8.41122 0.894197C8.21507 1.09035 8.10488 1.35638 8.10488 1.63378L8.11224 7.96091L1.78511 7.95355C1.50771 7.95355 1.24168 8.06374 1.04553 8.25989C0.849378 8.45604 0.739183 8.72208 0.739183 8.99948C0.739183 9.27687 0.849378 9.54291 1.04553 9.73906C1.24168 9.93521 1.50771 10.0454 1.78511 10.0454L8.11224 10.038L8.10488 16.3652C8.10431 16.5027 8.13098 16.6389 8.18335 16.7661C8.23571 16.8932 8.31273 17.0088 8.40997 17.106C8.5072 17.2032 8.62273 17.2803 8.74988 17.3326C8.87703 17.385 9.01329 17.4117 9.15081 17.4111C9.28832 17.4117 9.42458 17.385 9.55173 17.3326C9.67889 17.2803 9.79441 17.2032 9.89165 17.106C9.98888 17.0088 10.0659 16.8932 10.1183 16.7661C10.1706 16.6389 10.1973 16.5027 10.1967 16.3652L10.1894 10.038L16.5165 10.0454C16.654 10.046 16.7903 10.0193 16.9174 9.96694C17.0446 9.91457 17.1601 9.83755 17.2573 9.74032C17.3546 9.64308 17.4316 9.52755 17.484 9.4004C17.5363 9.27325 17.563 9.13699 17.5624 8.99947C17.563 8.86196 17.5363 8.7257 17.484 8.59855C17.4316 8.4714 17.3546 8.35587 17.2573 8.25864C17.1601 8.1614 17.0446 8.08438 16.9174 8.03201C16.7903 7.97965 16.654 7.95298 16.5165 7.95355L10.1894 7.96091Z'
        fill={color}
      />
    </svg>
  );
};

export default AddSVG;
